import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentService, SiteContentLocation, SiteContentHome } from '../../services/content.service';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer implements OnInit {
  content$!: Observable<any>;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.content$ = forkJoin({
      location: this.contentService.getLocationContent(),
      home: this.contentService.getHomeContent()
    });
  }

  getLogoUrl(home: SiteContentHome | undefined | null): string {
    if (home && home.logoImage) {
      return home.logoImage.startsWith('http') ? home.logoImage : 'https://dev.thehuskbakery.com/' + home.logoImage;
    }
    return '/images/logo.png';
  }
}
